module.exports = __webpack_public_path__ + "static/media/fan-fair-tickets.cf8f0fa2.png";